/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const NameMenuDarkTrue = ({ color = "white", className }) => {
  return (
    <svg
      className={`name-menu-dark-true ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M3 12H21"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99832"
      />

      <path
        className="path"
        d="M3 6H21"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99832"
      />

      <path
        className="path"
        d="M3 18H21"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.99832"
      />
    </svg>
  );
};

NameMenuDarkTrue.propTypes = {
  color: PropTypes.string,
};
